<div class="container1" [class.example-is-mobile]="mobileQuery.matches">
  <mat-toolbar color="" class="toolbar">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <h2 class="app-name" >{{title}}</h2>
    <div class="col-md-8 salute salute-container">
      @if (showNotifications) {
        <a (click)="notificationClick()" style="margin-top: 8px;">
          <mat-icon class="notification-icon" matBadge="{{notification.notificationCount}}" matBadgeSize="medium"
            matBadgeHidden="{{hasReadNotifications}}" matTooltip="{{notification.notificationDetails}}" [matTooltipPosition]="'below'">notifications
          </mat-icon>
        </a>
      }
      <span>
        Hi {{aduser}}
        [
        @if (!isProduction) {
          <a (click)="showProfile()" style="text-decoration: none;">{{adrole}}</a>
        } @else {
          {{adrole}}
        }
        ]
        <a (click)="logout()">Sign out</a>
      </span>
    </div>
  </mat-toolbar>

  <!-- <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
  <mat-sidenav #sidenav mode="side" opened="true" class="sidenav" [ngStyle]="{ 'width.em': sidenavWidth }" #snav
    [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56"
    (mouseenter)="increase()" (mouseleave)="decrease()"> -->

    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav #sidenav mode="side" opened="true" class="sidenav" #snav >
        <mat-nav-list>
          <br>
            <br>
              <mat-list-item routerLink="." routerLinkActive="active">
                <div class="nav-item">
                  <span class="material-icons">dashboard</span>
                  @if (sidenavWidth > 6) {
                    <span class="nav-text">Dashboard</span>
                  }
                </div>
              </mat-list-item>

              @if (profileClaims.submitKaizen) {
                <mat-list-item routerLink="/addEditKaizen">
                  <div class="nav-item">
                    <span class="material-icons">add_box</span>
                    @if (sidenavWidth > 6) {
                      <span class="nav-text">New Kaizen</span>
                    }
                  </div>
                </mat-list-item>
              }

              @if (profileClaims.submitKaizen) {
                <mat-list-item routerLink="/mykaizens">
                  <div class="nav-item">
                    <span class="material-icons">toc</span>
                    @if (sidenavWidth > 6) {
                      <span class="nav-text">My Kaizens</span>
                    }
                  </div>
                </mat-list-item>
              }

              @if (profileClaims.planApprovalforBudget) {
                <mat-list-item routerLink="/cmdreview">
                  <div class="nav-item">
                    <span class="material-icons">toc</span>
                    @if (sidenavWidth > 6) {
                      <span class="nav-text">CMD Review</span>
                    }
                  </div>
                </mat-list-item>
              }

              @if (profileClaims.planApprovalforBudget) {
                <mat-list-item routerLink="/forecastadjustments">
                  <div class="nav-item">
                    <span class="material-icons">toc</span>
                    @if (sidenavWidth > 6) {
                      <span class="nav-text">Forecast Adjustments</span>
                    }
                  </div>
                </mat-list-item>
              }
              <br>
                <div class="version">V 1.21.0</div>
              </mat-nav-list>


            </mat-sidenav>
            <mat-sidenav-content class="overflow contentheight">

              @if (loaderService.isLoading | async) {
                <div class="loader-container">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar> 
                  <!-- <mat-spinner style="top:50%; left:50%"></mat-spinner> -->
                </div>
              }
              <router-outlet></router-outlet>
            </mat-sidenav-content>
          </mat-sidenav-container>
        </div>